import React from 'react';
// import { Link } from 'react-router-dom';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
import * as specialistActions from '../../actions/specialistActions';
import {
	Modal,
} from 'react-bootstrap';
// import classNames from 'classnames';
import moment from 'moment';
// import validator from './../common/validator.js';
import StarRatingComponent from 'react-star-rating-component';
import * as constant from '../../constants/constant';
import Moment from 'react-moment';
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";

const autoBind = require('auto-bind');
const style = {
	fontWeight: 600,
	fontSize: 14
}

class FeedbackDetail extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			myFeedbackDetail: [],
			FeedbackDetail: {},
			specialistComment: ''
		};
		//binding current context to all functions
		this.onChange = this.onChange.bind();
		this.addSpecialistFeedback = this.addSpecialistFeedback.bind();
		this.editSpecialistFeedback = this.editSpecialistFeedback.bind();
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)

	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		browserHistory.push('/');
	}
	toggle() {

		$("body").toggleClass("sidebar-collapse");
	}
	editSpecialistFeedback(event) {
		event.preventDefault();
		var obj = {
			feedbackId: (this.state.FeedbackDetail && this.state.FeedbackDetail._id ? this.state.FeedbackDetail._id : ''),
			appointmentId: (this.state.FeedbackDetail && this.state.FeedbackDetail.aptId ? this.state.FeedbackDetail.aptId : ''),
			doctorFeedback: this.state.specialistComment,
			userId: localStorage.getItem('userId'),
			oldFeedback: (this.state.FeedbackDetail && this.state.FeedbackDetail.doctorFeedback ? this.state.FeedbackDetail.doctorFeedback : '')
		}

		this.props.actions.editRatingBySpecialist(obj);
		this.props.callListAgain();
		// var obj = {
		// 	doctorId: localStorage.getItem('userId'),
		// 	appointmentId: this.props.appId,
		// 	patientId: this.props.pId
		// }
		// this.props.actions.getRatingDetail(obj);
	}

	addSpecialistFeedback(event) {
		event.preventDefault();
		var doctorName = JSON.parse(localStorage.getItem('user'));

		var obj = {
			patientId: this.props.pId,
			appointmentId: this.props.appId,
			doctorFeedback: this.state.specialistComment,
			specialistId: localStorage.getItem('userId'),
			doctorName: doctorName.firstName + " " + doctorName.lastName
		}
		this.props.actions.respondToPatient(obj);
		this.props.callListAgain();
	}
	onChange(event) {
		var state = this.state;
		state[event.target.name] = event.target.value;
		this.setState(state);
	}

	componentWillReceiveProps(nextProps) {

		var state = this.state;
		if(nextProps.myFeedbackDetail.ratingDetail){
		state.myFeedbackDetail = nextProps.myFeedbackDetail.ratingDetail ? nextProps.myFeedbackDetail.ratingDetail : [];
		state.FeedbackDetail = nextProps.myFeedbackDetail.feedbackDetail ? nextProps.myFeedbackDetail.feedbackDetail : this.state.FeedbackDetail;


		this.setState(state);
		}
	}
	componentWillMount() {

		var obj = {
			doctorId: localStorage.getItem('userId'),
			appointmentId: this.props.appId,
			patientId: this.props.pId
		}
		this.props.actions.getRatingDetail(obj);
	}

	render() {
		var myFeedbackDetail = this.state.myFeedbackDetail;
		var FeedbackDetail = this.state.FeedbackDetail;
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<Modal show={this.props.openModal} size="modal-sm" onHide={this.props.closeModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.closeModal} /> */}
				</Modal.Header>
				<Modal.Body>
					<form className="signup-form" id="feedbackDetailForm" >
						<div style={style}>

							<div className="row" style={{ marginBottom: 30, textAlign: 'center' }}>
								<div className="col-sm-3">
									{/* {this.props.patientDetail.profileImage == constant.DEFAULT_USER_IMAGE ?  */}
									<img style={{ width: 60, height: 60, borderRadius: '50%' }} src={this.props.myFeedbackDetail.patientData && this.props.myFeedbackDetail.patientData[0].userId.gender == 'Male' ?
									constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'patient_m.png' :
									constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'patient_f.png'} alt="User profile picture" />
									{/* : <img style={{ width: 60, height: 60, borderRadius: '50%' }} src={constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + this.props.pId + '/' + this.props.patientDetail.profileImage} alt="User profile picture" />} */}
								</div>
								<div className="col-sm-9 myFeedbacks" >
									<div>
										Patient Name :	<span className="text-capitalize">{this.props.patientDetail.userName}</span>
									</div>
									<div>
										Appointment Date :
										<span style={{ marginLeft: 2 }}>
											<Moment format="DD-MM-YYYY">
												{this.props.appDate}
											</Moment>
										</span>

									</div>
									<div>
										Appointment Time :
										<span >{moment.parseZone(new Date(this.props.appDate)).format('hh:mm A') + " " + userlocation}</span>

									</div>


									<div >
										Average Rating :
										<span className="avgRate_feedback" >
											<StarRatingComponent
												name="avgRate"
												id={'avgRate'}
												editing={false}
												starCount={5}
												emptyStarColor={'#D3D3D3'}
												renderStarIcon={(index, value) => {
													return (
														<span >
															{index <= value ? <span style={{
																marginTop: -7,
																marginLeft: 4
															}} ><img className="rateStarSize" src={require('../../images/start_icon.png')} /></span> : <span style={{
																marginTop: -7,
																marginLeft: 4
															}}><img className="rateStarSize" src={require('../../images/start_icon_off.png')} /></span>}
														</span>
													);
												}}
												value={Math.round(this.props.avgRating)}
											/>
										</span>
									</div>
								</div>
							</div>

							{(myFeedbackDetail && myFeedbackDetail.length) > 0 ?
								myFeedbackDetail.map((option, index) =>
									<div key={index} className="row tatingStart">

										<div className="col-lg-8">{option.ratingQId.question}</div>
										<div className="col-lg-4">
											<StarRatingComponent
												name={'rate' + index}
												id={'rate' + index}
												value={option.value}
												editing={false}
												starCount={5}
												emptyStarColor={'#D3D3D3'}
												renderStarIcon={(index, value) => {
													return (
														<span>
															{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span><img src={require('../../images/start_icon_off.png')} /></span>}
														</span>
													);
												}}
											/>
										</div>
									</div>)
								: ''}
							<div>
								<br />
								{FeedbackDetail.patientFeedback ? (<div><div><span className="text-capitalize">{this.props.patientDetail.userName}'s </span>experience with you</div>
									<div style={{ fontWeight: 400, fontSize: 14 }} name='feedback' >{FeedbackDetail.patientFeedback ? FeedbackDetail.patientFeedback : ''}</div> <br /></div>) : ''}


								{(FeedbackDetail.patientFeedback || FeedbackDetail.patientFeedback == '') && FeedbackDetail.isDoctorAddedFeedback == false ? (<div>
									<p>Tell us about your experience with <span className="text-capitalize">{this.props.patientDetail.userName} </span></p>
									<textarea className="form-control textinput" id="fake-file-input-name" placeholder="Type here..." value={this.state.specialistComment} onChange={this.onChange} name='specialistComment' />
									<br />
									<button type="submit" className="btn btn-warning btn-lg" onClick={this.addSpecialistFeedback}>Add Comment{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>

								</div>) : ''}

								{FeedbackDetail.doctorFeedback && FeedbackDetail.isDoctorAddedFeedback == true ? (<div>
									<p>Your experience with <span className="text-capitalize">{this.props.patientDetail.userName} </span></p>
									<textarea className="form-control textinput" id="fake-file-input-name" value={FeedbackDetail.doctorFeedback ? FeedbackDetail.doctorFeedback : ''} placeholder="Type here..." name='feedback' />
									<br />
									<div className="row" >
										{FeedbackDetail && FeedbackDetail.isSpecialistVerified ? < div className="row" style={{ marginLeft: 20 }}>
											< p > Has this feedback been moderated:</p> <span style={{ fontWeight: 500, paddingLeft: 5 }}>
												{FeedbackDetail.isSpecialistVerified == true ? "Yes" : "No"}</span>
										</div> : ''}

										{FeedbackDetail && FeedbackDetail.isSpecialistVerified == false && FeedbackDetail.isAdminVerfiedSpecialistOnce == true ?
											< div className="tsbGrayBox" style={{ marginLeft: -1 }}>
												<p style={{ marginLeft: 13 }}>Your feedback is rejected by admin you can again give feedback to specialist</p>
												< div className="col-md-12 text-center">
													<div className="boxMrgB btnBtm">
														<textarea className="form-control textinput" id="fake-file-input-name" placeholder="Type here..." value={this.state.specialistComment} onChange={this.onChange} name='specialistComment' />
														<br />
														<button type="submit" className="btn btn-warning btn-lg" onClick={this.editSpecialistFeedback}>Add Comment Again{this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>

													</div>
												</div>
											</div> : ''}

									</div>
								</div>
								)

									: ''}
							</div>
							{/* <div  >
								<h4  className="feedbackBtn">Disclaimer</h4>
								<p >Your feedback should not identify or make reference to any individual, living or otherwise, in any way, whether in a positive or negative light.  You must also be objective in your feedback, with an emphasis on tangible actions recorded in your feedback post.  The aim of the feedback mechanism is to guide other prospective patients, any official or unofficial complaints should be followed up with Medfix Support Team.  All posts are moderated before being published and may be declined or withdrawn at any time.  Your use of the feedback system constitutes acceptance of the Medfix Terms and Conditions.</p>
							</div> */}
						</div>
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		myFeedbackDetail: state.specialist.myFeedbackDetail,
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(FeedbackDetail);
// export default (FeedbackDetail);
